import type { NotificationTransitionInterventionCardProps } from "./notification-transition-intervention-card.type";

import { Typography } from "antd";
import { Trans, useTranslation } from "react-i18next";

import { BatchPreviewTransitionLink } from "@/modules/batch-preview/batch-preview-transition-link";
import ModelIcon from "@/modules/model-icon";
import { ModelLink } from "@/modules/model-link";
import { NotificationCard } from "@/modules/notification/notification-card";
import { useNotificationsPanel } from "@/modules/notifications/notifications-panel";
import { OrganizationContextLabel } from "@/modules/organization/organization-context-label";
import { StateTag } from "@/modules/state-tag";

const { Paragraph } = Typography;

export const NotificationTransitionInterventionCard = ({
  notification,
}: NotificationTransitionInterventionCardProps) => {
  const { t } = useTranslation();
  const { closePanel } = useNotificationsPanel();

  const { type, data } = notification;
  const { context, state, interventions, user } = data;
  const color = "var(--app-color-info)";
  const count = interventions.length;
  const ids = interventions.map(({ id }) => id);

  return (
    <NotificationCard
      notification={notification}
      icon={<ModelIcon model="intervention" style={{ color }} />}
      title={t("notification:interventionTransition.title", { count })}
      color={color}
      subTitle={user.name}
      content={
        <Paragraph ellipsis={{ rows: 2 }}>
          <Trans
            i18nKey="notification:interventionTransition.description"
            values={{
              userName: user.name,
              interventionName: interventions[0]?.name ?? "",
              count,
            }}
            components={{
              StateTag: <StateTag value={state} type="intervention" asText />,
            }}
          />
        </Paragraph>
      }
      actions={
        <>
          {count === 1 ? (
            <ModelLink
              model="intervention"
              item={interventions[0]}
              showIcon="external"
              modelAsName
              customContext={context}
              onClick={closePanel}
            />
          ) : (
            <BatchPreviewTransitionLink
              type={type}
              state={state}
              userName={user.name}
              ids={ids}
              customContext={context}
              onClick={closePanel}
              icon="external"
            />
          )}
          <OrganizationContextLabel context={context} isSmall />
        </>
      }
    />
  );
};
